// Module
var code = "<div> <label data-bind=\"attr: { title: Label }\"> <i class=\"fa fa-bar-chart\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;